import React from 'react';

import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

interface DeleteFailedSaveToResultsStepBannerProps {
  /**
   * If defined, an action to Delete step will be shown.
   * If undefined, the action will not be shown.
   */
  deleteStep?: () => void;
  text?: string;
  supportingInfo?: string;
}

export default function DeleteFailedSaveToResultsStepBanner(
  props: DeleteFailedSaveToResultsStepBannerProps
): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.ERROR}
      text={props.text ?? 'Error saving to results'}
      supportingInfo={props.supportingInfo}
      action={
        props.deleteStep
          ? {
              actionType: InlineBannerActionType.CUSTOM,
              actionText: 'Delete step',
              actionOnClick: props.deleteStep,
            }
          : undefined
      }
    />
  );
}
